// - Headers Isapres
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'nombre',
        value: 'type',
    },
]
